import { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import ContentHeader from '../components/ContentHeader';
import { supabase } from '../supabaseClient';
import JobsList from '../components/JobsList';

const JobsPage = () => {
  const [error, setError] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);


  const cancelJob = async (id) => {
    //  TODO: call backend cancel API here
    console.log(id);
  };

  const fetchJobs = async () => {
    try {
      setLoading(true);
      const { data: circuitJobs, error: fetchError } = await supabase
        .from("jobs")
        .select("*, snapshots( id, hash, created_at, circuits (id, name, frameworks (id, name, version )))")
        .order("created_at", { ascending: false });

      if (fetchError) throw fetchError;
      console.log(circuitJobs);
      setJobs(circuitJobs);
      setLoading(false);
    } catch (err) {
      setError(`Failed to load circuit jobs: ${err.message}`);
      console.error("Error fetching circuit jobs:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, [])

  return (
    <div className="columns" style={{ height: '100vh', display: 'flex', flexDirection: 'row' }}>
      <Sidebar />
      <div className="column p-6 has-background-light">
        <ContentHeader title="Jobs" subtitle="History of submitted jobs" />
        {loading && <div className="skeleton-block mt-5 p-5" style={{ height: '50vh' }}></div>}
        {error && <div className="notification is-danger mt-5" role="alert">
          <button className="delete" onClick={() => { setError(null) }}></button>
          <strong>Error:</strong> {error}
        </div>}
        {!error && !loading &&
          <JobsList jobs={jobs} onCancelJob={cancelJob}/>
        }
      </div>
    </div>
  );
};

export default JobsPage;
